import { useEffect, useState } from 'react';
import axios from 'axios';
import { MapPin, Clock, Phone, Mail } from 'lucide-react';
import { PageShell } from '../components/PageShell';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PokerRoomPage = () => {
  const [page, setPage] = useState(null);
  useEffect(() => {
    axios.get(`${API}/pages/poker-room`).then(r => setPage(r.data)).catch(() => {});
  }, []);

  return (
    <PageShell>
      <section className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <p className="font-heading text-[10px] tracking-[0.4em] uppercase text-primary-main/80 mb-3">The Floor</p>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white">
          {page?.title || 'The Poker Room'}
        </h1>
        {page?.subtitle && <p className="mt-3 font-body text-lg text-white/60">{page.subtitle}</p>}

        {page?.image_url && (
          <div className="mt-10 rounded-2xl overflow-hidden border border-white/[0.06]">
            <img src={page.image_url} alt={page.title} className="w-full block" />
          </div>
        )}

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 prose-content">
            {page?.body ? (
              <div
                className="font-body text-base text-white/75 leading-relaxed whitespace-pre-wrap"
                data-testid="poker-room-body"
              >{page.body}</div>
            ) : (
              <div className="font-body text-base text-white/40 italic">
                Content coming soon — admins can edit this page from the dashboard.
              </div>
            )}
          </div>

          <aside className="space-y-4">
            <InfoCard icon={<MapPin className="w-5 h-5 text-primary-main" />} label="Address" value={page?.address || 'TBA'} />
            <InfoCard icon={<Clock className="w-5 h-5 text-primary-main" />} label="Hours" value={page?.hours || 'Open daily'} />
            <InfoCard icon={<Phone className="w-5 h-5 text-primary-main" />} label="Phone" value={page?.phone || '—'} />
            <InfoCard icon={<Mail className="w-5 h-5 text-primary-main" />} label="Email" value={page?.email || '—'} />
          </aside>
        </div>
      </section>
    </PageShell>
  );
};

const InfoCard = ({ icon, label, value }) => (
  <div className="rounded-xl border border-white/[0.06] bg-white/[0.02] p-4 flex items-start gap-3">
    <div className="flex-shrink-0 mt-0.5">{icon}</div>
    <div>
      <p className="font-heading text-[10px] tracking-[0.2em] uppercase text-white/40">{label}</p>
      <p className="font-body text-sm text-white/85 mt-1">{value}</p>
    </div>
  </div>
);

export default PokerRoomPage;
